export const platformStats = {
    clinics: 7,
    patients: 246,
    doctors: 26,
    groups: 48,
    activeTrainingPlans: 6560,
    exercisesCompleted: 186750,
    alertsDetected: 365,
    questionnairesAnswered: 186
};

export const platformEvolution = [
    {
        month: '2024-01-01',
        patients: 120,
        clinics: 3,
        exercises: 15000
    },
    {
        month: '2024-02-01',
        patients: 160,
        clinics: 4,
        exercises: 32000
    },
    {
        month: '2024-03-01',
        patients: 200,
        clinics: 6,
        exercises: 98000
    },
    {
        month: '2024-04-01',
        patients: 246,
        clinics: 7,
        exercises: 186750
    },
    {
        month: '2024-05-01',
        patients: 120,
        clinics: 6,
        exercises: 267750
    },
    {
        month: '2024-06-01',
        patients: 187,
        clinics: 9,
        exercises: 346750
    },
    {
        month: '2024-07-01',
        patients: 289,
        clinics: 16,
        exercises: 786750
    },
    {
        month: '2024-08-01',
        patients: 468,
        clinics: 25,
        exercises: 1386750
    }
];

export const clinicsStats = [
    {
        uuid: '1',
        name: 'ConnectedHeart Demo 1',
        doctors: 6,
        patients: 120
    },
    {
        uuid: '2',
        name: 'ConnectedHeart Demo 2',
        doctors: 4,
        patients: 80
    },
    {
        uuid: '3',
        name: 'ConnectedHeart Demo 3',
        doctors: 3,
        patients: 46
    },
    {
        uuid: '4',
        name: 'ConnectedHeart Demo 4',
        doctors: 7,
        patients: 152
    },
    {
        uuid: '5',
        name: 'ConnectedHeart Demo 5',
        doctors: 9,
        patients: 156
    },
    {
        uuid: '6',
        name: 'ConnectedHeart Demo 6',
        doctors: 5,
        patients: 57
    }
];

export const clinicAnalyticsById = {
    1: {
        uuid: '1',
        name: 'ConnectedHeart Demo 1',
        logo_url: '',
        doctors: 6,
        patients: 120,
        groups: 12,
        activeTrainingPlans: 320,
        exercisesCompleted: 86000,
        alertsDetected: 120,
        questionnairesAnswered: 64,
        evolution: [
            { month: '2024-01-01', patients: 80, exercises: 12000 },
            { month: '2024-02-01', patients: 95, exercises: 20000 },
            { month: '2024-03-01', patients: 110, exercises: 35000 },
            { month: '2024-04-01', patients: 120, exercises: 86000 },
            { month: '2024-04-01', patients: 98, exercises: 92000 },
            { month: '2024-05-01', patients: 156, exercises: 105000 },
            { month: '2024-06-01', patients: 189, exercises: 112000 },
            { month: '2024-07-01', patients: 167, exercises: 126000 }
        ]
    },
    2: {
        uuid: '2',
        name: 'ConnectedHeart Demo 2',
        logo_url: '',
        doctors: 4,
        patients: 80,
        groups: 8,
        activeTrainingPlans: 180,
        exercisesCompleted: 56000,
        alertsDetected: 70,
        questionnairesAnswered: 42,
        evolution: [
            { month: '2024-01-01', patients: 50, exercises: 9000 },
            { month: '2024-02-01', patients: 60, exercises: 15000 },
            { month: '2024-03-01', patients: 70, exercises: 30000 },
            { month: '2024-04-01', patients: 80, exercises: 56000 },
            { month: '2024-04-01', patients: 98, exercises: 72000 },
            { month: '2024-05-01', patients: 76, exercises: 87000 },
            { month: '2024-06-01', patients: 110, exercises: 102000 },
            { month: '2024-07-01', patients: 146, exercises: 116000 }
        ]
    },
    3: {
        uuid: '3',
        name: 'ConnectedHeart Demo 3',
        logo_url: '',
        doctors: 3,
        patients: 46,
        groups: 5,
        activeTrainingPlans: 90,
        exercisesCompleted: 42000,
        alertsDetected: 40,
        questionnairesAnswered: 25,
        evolution: [
            { month: '2024-01-01', patients: 30, exercises: 6000 },
            { month: '2024-02-01', patients: 35, exercises: 12000 },
            { month: '2024-03-01', patients: 40, exercises: 26000 },
            { month: '2024-04-01', patients: 46, exercises: 42000 },
            { month: '2024-04-01', patients: 56, exercises: 52000 },
            { month: '2024-05-01', patients: 76, exercises: 85000 },
            { month: '2024-06-01', patients: 67, exercises: 892000 },
            { month: '2024-07-01', patients: 87, exercises: 106000 }
        ]
    },
    4: {
        uuid: '4',
        name: 'ConnectedHeart Demo 4',
        logo_url: '',
        doctors: 6,
        patients: 120,
        groups: 12,
        activeTrainingPlans: 320,
        exercisesCompleted: 86000,
        alertsDetected: 120,
        questionnairesAnswered: 64,
        evolution: [
            { month: '2024-01-01', patients: 80, exercises: 12000 },
            { month: '2024-02-01', patients: 95, exercises: 20000 },
            { month: '2024-03-01', patients: 110, exercises: 35000 },
            { month: '2024-04-01', patients: 120, exercises: 86000 },
            { month: '2024-04-01', patients: 98, exercises: 92000 },
            { month: '2024-05-01', patients: 156, exercises: 105000 },
            { month: '2024-06-01', patients: 189, exercises: 112000 },
            { month: '2024-07-01', patients: 167, exercises: 126000 }
        ]
    },
    5: {
        uuid: '5',
        name: 'ConnectedHeart Demo 5',
        logo_url: '',
        doctors: 4,
        patients: 80,
        groups: 8,
        activeTrainingPlans: 180,
        exercisesCompleted: 56000,
        alertsDetected: 70,
        questionnairesAnswered: 42,
        evolution: [
            { month: '2024-01-01', patients: 50, exercises: 9000 },
            { month: '2024-02-01', patients: 60, exercises: 15000 },
            { month: '2024-03-01', patients: 70, exercises: 30000 },
            { month: '2024-04-01', patients: 80, exercises: 56000 },
            { month: '2024-04-01', patients: 98, exercises: 72000 },
            { month: '2024-05-01', patients: 76, exercises: 87000 },
            { month: '2024-06-01', patients: 110, exercises: 102000 },
            { month: '2024-07-01', patients: 146, exercises: 116000 }
        ]
    },
    6: {
        uuid: '6',
        name: 'ConnectedHeart Demo 6',
        logo_url: '',
        doctors: 3,
        patients: 46,
        groups: 5,
        activeTrainingPlans: 90,
        exercisesCompleted: 42000,
        alertsDetected: 40,
        questionnairesAnswered: 25,
        evolution: [
            { month: '2024-01-01', patients: 30, exercises: 6000 },
            { month: '2024-02-01', patients: 35, exercises: 12000 },
            { month: '2024-03-01', patients: 40, exercises: 26000 },
            { month: '2024-04-01', patients: 46, exercises: 42000 },
            { month: '2024-04-01', patients: 56, exercises: 52000 },
            { month: '2024-05-01', patients: 76, exercises: 85000 },
            { month: '2024-06-01', patients: 67, exercises: 892000 },
            { month: '2024-07-01', patients: 87, exercises: 106000 }
        ]
    }
};
